import React from 'react';
import Fade from 'react-reveal/Fade';

import { TextComponent } from 'design/text/textComponents';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { PressControlComponent } from 'design/pressControl';
import { ANIMATION_DEFAULT_DURATION } from 'utils/constants';
import { useAppState } from 'hooks/useAppState';
import { ContentLayoutComponent } from 'design/contentLayout';
import { MarginComponent } from 'design/margin';
import { useDemoStackURLProcess } from 'hooks/useDemoStackURLProcess';
import { useDemoStackCreationProcess } from 'hooks/useDemoStackCreationProcess';

export const DemoStackManagerAuthorized = () => {
  useDemoStackURLProcess();
  useDemoStackCreationProcess();

  const { demoStackManager: ownDictionary } = useIntlDictionary();

  const { demoStackUrl } = useAppState();

  const openDemoStack = React.useCallback(() => {
    if (demoStackUrl) {
      window.open(demoStackUrl, '_self');
    }
  }, [demoStackUrl]);

  return (
    <Fade duration={ANIMATION_DEFAULT_DURATION}>
      <ContentLayoutComponent
        title={ownDictionary.demoReadyTitleText()}
        body={
          <>
            <TextComponent>
              {ownDictionary.demoReadyDescriptionText}
            </TextComponent>
            {demoStackUrl && (
              <>
                <MarginComponent top={48} />
                <span>
                  <PressControlComponent
                    type="button"
                    theme="primary"
                    onPress={openDemoStack}
                  >
                    {ownDictionary.demoReadyActionText}
                  </PressControlComponent>
                </span>
              </>
            )}
          </>
        }
        backAction={null}
      />
    </Fade>
  );
};
